import React from 'react';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { editPublicacion } from '../../../../actions/publicacionesActions';

class DescripcionAmpliada extends React.Component {
    constructor(props) {
        super(props);
        this.editorRef = React.createRef(); // Crea la referencia para el editor
    }

    handleEditorChange = (content) => {
        const publicacion = { ...this.props.publicacion };

        // Verifica si el contenido es equivalente a un p�rrafo vac�o
        if (content === '<p><br></p>') {
            publicacion["descripcionAmpliada"] = '';
        } else {
            publicacion["descripcionAmpliada"] = content;
        }

        this.props.editPublicacion(publicacion);
    };

    handleContainerClick = () => {
        if (this.editorRef.current) {
            const quillEditor = this.editorRef.current.getEditor();
            const selection = quillEditor.getSelection();

            if (!selection || selection.index === null) {
                // Si no hay selecci�n (clic en �rea vac�a), mueve el cursor al final
                const contentLength = quillEditor.getLength();
                quillEditor.focus(); // Enfoca el editor
                quillEditor.setSelection(contentLength - 1, 0); // Posiciona al final del contenido
            }
            // Si hay selecci�n, permite que el cursor quede donde el usuario clic�
        }
    };

    render() {
        return (
            <div onClick={this.handleContainerClick} style={{ cursor: 'text' }}>
                <ReactQuill
                    ref={this.editorRef}
                    theme="snow"
                    modules={DescripcionAmpliada.modules}
                    value={this.props.publicacion.descripcionAmpliada}
                    onChange={this.handleEditorChange}
                />
            </div>
        );
    }
}

DescripcionAmpliada.modules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }], // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }], // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent
        [{ 'direction': 'rtl' }], // text direction
        [{ 'size': ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['clean']
    ]
};

const mapStateToProps = state => ({
    publicacion: state.publicaciones.publicacion,
    tipoUsuario: state.general.tipoUsuario
});

export default connect(mapStateToProps, { editPublicacion })(DescripcionAmpliada);
